import LanguageNotice from './language-notice';

export default {
  init: function (selector) {
    const languageNotices = document.querySelectorAll(selector);

    if (languageNotices && languageNotices.length) {
      [...languageNotices].map(item => {
        const languageNotice = new LanguageNotice(item);
        languageNotice.init();
      });
    }
  }
};
